
namespace Matrix.DataAudit {

    const __id = "__id";

    @Serenity.Decorators.registerClass()
	export class SingleAccountHistoryGrid extends AccountHistoryGrid {

        protected getIdProperty() { return __id; }

        protected getInitialTitle() {
			return null;
		}

		protected getColumns() {
            var columns = super.getColumns().filter(x => x.field != AccountHistoryRow.Fields.AccountCode);

            var edit = Q.tryFirst(columns, x => x.field == "Edit");
            if (edit) {
                edit.headerFilterType = Serenity.HeaderFilterType.disabled;
                edit.format = () => this.editMode ? `<a class="inline-action edit-history" title="Edit">
<i class="fa fa-pencil-square-o text-purple"></i></a>` : '';
            }

            if (!Authorization.userDefinition.UsePreviewFeatures) {
                var dateFrom = Q.tryFirst(columns, x => x.field == "DateFrom");
                dateFrom && (dateFrom.field = "CurrentFrom");
                var dateTo = Q.tryFirst(columns, x => x.field == "DateTo");
                dateTo && (dateTo.field = "CurrentTo");
            }

            return columns;
		}

		protected getGridCanLoad() {
			return !!this._accountCode;
		}

		private _accountCode: string;

		public get accountCode() {
			return this._accountCode;
		}

		public set accountCode(value: string) {
			if (this._accountCode != value) {
				this._accountCode = value;
				this.setEquality(AccountHistoryRow.Fields.AccountCode, value);
				this.refresh();
			}
		}

		protected usePager() {
			return false;
		}

		protected getViewOptions() {
			var opt = super.getViewOptions();
			opt.localSort = true;
			return opt;
		}

        private lastId: number = 0;

        protected onViewProcessData(response: Serenity.ListResponse<AccountHistoryRow>) {
            response = super.onViewProcessData(response);

            for (var x of response.Entities) {
                (x as any)[__id] = ++this.lastId;
            }
            return response;
        }

        protected editItem(entityOrId: any) {
            if (typeof entityOrId == "string" || typeof entityOrId == "number") {
                var item = this.view.getItemById(entityOrId);
                if (item != null)
                    super.editItem(item.AccountKey);
            }
            else
                super.editItem(entityOrId);
        }

        protected getButtons() {
            var buttons = super.getButtons();

            if (Authorization.userDefinition?.UsePreviewFeatures) {
                buttons.push({
                    hint: 'Toggle Edit Mode',
                    cssClass: 'toggle-edit-mode-button',
                    icon: 'fa-pencil-square-o',
                    onClick: () => {
                        this.editMode = true;
                        this.toolbar.element.find('.history-range').show();
                        this.toolbar.findButton('toggle-edit-mode-button').hide();
                        this.slickGrid.invalidate();
                    }
                });
            }
            return buttons;
        }

        private editMode: boolean;

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            var rngDiv = $(`<div class="history-range"><span>Effective Date Range</span>
<input type="text" class="history-range-start" style="width: 90px" />
<span class="sep">-</span>
<input type="text" class="history-range-end" style="width: 90px" />
<i class="fa fa-times-circle-o" title="clear range" style="font-size: 18px;
    position: relative;
    color: #444;
    top: 2px;
    cursor: pointer;
    opacity: 0.2;"></i>
<button class="btn btn-small edit-history-button disabled" style="position: relative;
    top: -2px;
    border: 1px solid #ddd;
    background: none;
    font-size: 13px;
    margin-left: 2px;
    padding: 6px 8px 5px 8px;"><i class="fa fa-pencil-square-o" style="font-size: 16px; 
float: left; 
margin-right: 3px;
margin-top: 1px;"></i> Edit History</button>
</div>`).appendTo(this.toolbar.element).hide();

            var start = new Serenity.DateEditor(rngDiv.children('.history-range-start'));
            var end = new Serenity.DateEditor(rngDiv.children('.history-range-end'));
            rngDiv.find('.ui-datepicker-trigger').css({
                position: 'relative',
                top: '3px'
            });
            var datesChange = (e: Event) => {
                if (start.element.is(e.target) &&
                    start.valueAsDate != null &&
                    end.valueAsDate == null) {
                    var max = null;
                    for (var x of this.view.getItems()) {
                        if (x.DateTo != null && (max == null || max < x.DateTo)) {
                            max = x.DateTo;
                        }
                    }
                    end.value = max;
                }
                rngDiv.children('.edit-history-button').toggleClass('disabled', !this.accountCode ||
                    !start.valueAsDate || !end.valueAsDate || start.valueAsDate > end.valueAsDate ||
                    !Q.Authorization.hasPermission('DataAdmin:AccountHistory'));
                this.refresh();
                rngDiv.find('.fa-times-circle-o').css('opacity', start.value || end.value ? 1 : 0.2);
            };
            start.element.add(end.element).change(datesChange);
            rngDiv.children('.edit-history-button').click(() => {
                var dlg = new AccountHistoryEditDialog();
                this.initDialog(dlg);
                dlg.editHistory(this.accountCode, start.valueAsDate, end.valueAsDate, true);
            });
            rngDiv.find('.fa-times-circle-o').click(() => {
                start.value = null;
                end.value = null;
                datesChange({
                    target: start
                } as any);
            });
        }

        protected getInsertPermission() {
            return "NoPermission";
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var prm = this.view.params as AccountHistoryListRequest;

            prm.ViewUnion = !!Authorization.userDefinition?.UsePreviewFeatures;

            var s = this.toolbar.element.find('.history-range-start').getWidget(Serenity.DateEditor).valueAsDate;
            var e = this.toolbar.element.find('.history-range-end').getWidget(Serenity.DateEditor).valueAsDate;
            prm.StartDate = !s ? null : Q.formatDate(s, 'yyyy-MM-dd');
            prm.EndDate = !e ? null : Q.formatDate(e, 'yyyy-MM-dd');

            return true;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as AccountHistoryRow;
            var target = $(e.target);

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('edit-history')) {
                    AccountHistoryService.Retrieve({
                        EntityId: item.AccountKey
                    },
                        response => {
                            var entity = response.Entity;
                            entity.DateFrom = item.DateFrom;
                            entity.DateTo = item.DateTo;
                            var dlg = new AccountHistoryEditDialog();
                            this.initDialog(dlg);
                            dlg.editHistoryWith(entity, true);
                        });
                }
            }
        }
	}
}